<div class="fx-gap-xs header page-header border-bottom" lcClass.gt-sm="fx-row x-space-between" lcClass.lt-md="fx-column">

  <div class="fx-column fx-grow">
    @if (header) {
      <h1 class="page-title m-0">{{header}}</h1>
    }
    @if (subheader) {
      <h4 class="mat-title m-0 page-subtitle">{{subheader}}</h4>
    }
  </div>

  @if (caption) {
    <div class="fx-column fx-1-1-auto" lcClass.gt-sm="text-right">
      <span class="mat-caption m-0 page-caption">{{caption}}</span>
    </div>
  }


</div>
